import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/financial-reports/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/supporter/$supporterId/financial-reports/invoices",
      params: { supporterId: params.supporterId },
    });
  },
});
